import 'whatwg-fetch';

import * as storage from 'client/javascript/storage';
import getClosestMarket from 'client/javascript/get_closest_market';
import { shouldShowExperimentVariant } from 'client/javascript/experiments';
import { varsFromServer } from 'client/javascript/client_side_injection_vars';
import { sendBucketEvent } from 'client/javascript/heap';
import { logError } from 'client/javascript/util/logger';

import {
  NUMBER_OF_RESULTS,
  BUILDINGS_NEAR_ME_EXPERIMENT,
  nearbyBuildingsSectionContainerId,
  nearbyBuildingsSlider
} from 'server/controllers/nearby_buildings/constants';

export function isNearbyBuildingsAvailable() {
  return document.querySelector(nearbyBuildingsSlider);
}

function getNearbyBuildingsSection(marketId) {
  return fetch(`${varsFromServer.locale}/nearby_buildings?marketId=${marketId}`);
}

export async function populateNearbyBuildingsSection() {
  if (isNearbyBuildingsExperimentVariant()) {
    const locationId = await getLocationId();
    const nearbyBuildingsContainer = document.getElementById(nearbyBuildingsSectionContainerId);

    try {
      const nearbyBuildingsResponse = await getNearbyBuildingsSection(locationId);
      nearbyBuildingsContainer.innerHTML = await nearbyBuildingsResponse.text();
    } catch (error) {
      logError('Nearby buildings failed with an error', error);
    }
  }
  sendBucketEvent(BUILDINGS_NEAR_ME_EXPERIMENT, { triggerHotjar: true });
}

function isNearbyBuildingsExperimentVariant() {
  return shouldShowExperimentVariant(varsFromServer.experimentsString, BUILDINGS_NEAR_ME_EXPERIMENT);
}

export async function getLocationId() {
  const closestMarket = (await getClosestMarket(NUMBER_OF_RESULTS)) || {};
  const locationIdFromLocalStorage = storage.getLocationId();
  return locationIdFromLocalStorage || closestMarket.id;
}
